import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from '../services/storage.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard {
  noPermissions: string = '';
  accessDenied: string = '';

  constructor(
      public router: Router,
      private toastrService: ToastrService,
      private storageService: StorageService,
      private translateService: TranslateService
  ) {
    this.noPermissions = this.translateService.instant('errors.no_permissions');
    this.accessDenied = this.translateService.instant('errors.access_denied'); 
  }

  canActivate(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // console.log('canActivate chiamato per:', state.url);
    let user = this.storageService.getFromLocalOrSessionStorage('user') || '{}';

    // Controllo se `roles` è definito, altrimenti lo prende dal genitore
    const requiresAdmin = route.data?.['requiresAdmin'] ?? route.parent?.data?.['requiresAdmin'];
    const allowedRoles: string[] =
        Array.isArray(route.data?.['roles']) ? route.data['roles'] :
            Array.isArray(route.parent?.data?.['roles']) ? route.parent?.data['roles'] : [];

    // Controllo se l'utente ha i permessi necessari
    if (!user || !Object.keys(user).length) {
      this.router.navigate(['/auth/login']);
      return false;
    } else {
      // Controllo se il ruolo dell'utente è tra i ruoli autorizzati
      if (allowedRoles.length === 0 || allowedRoles.includes(user.role)) {
        return true;
      } else if (user.role) {
        this.toastrService.error(
            this.noPermissions,
            this.accessDenied,
            {
              positionClass: 'toast-bottom-right',
              tapToDismiss: true
            }
        );
      }
      return false;
    }
  }
}
